import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import {ImSpinner} from 'react-icons/im'

function MovieDetails() {
  const { id } = useParams()
  const [movie, setMovie] = useState({})
  const [videos, setVideos] = useState([])
  const [loading, setLoading] = useState(true)
  const [trailer, setTrailer] = useState(true)
  console.log(id)
  const url = `https://api.themoviedb.org/3/movie/${id}?api_key=ebec19ef414c8e83498a235dedd94d8b`
  const movie_url = `https://api.themoviedb.org/3/movie/${id}/videos?api_key=ebec19ef414c8e83498a235dedd94d8b`

  useEffect(() => {
    const details = async () => {
      await axios
        .get(url)
        .then((res) => {
          setMovie(res.data)
          console.log(res)
          setTimeout(() => {
      setLoading(false);
    }, 3000);
        })
        .catch((error) => {
          console.log(error)
        })
    }
    details()
  }, [id])

  useEffect(() => {
    const details = async () => {
      await axios
        .get(movie_url)
        .then((res) => {
          setVideos(res.data.results)
          setTimeout(() => {
            setLoading(false)
          }, 2000)
          console.log(res, 'jjjj')
        })
        .catch((error) => {
          console.log(error)
        })
    }
    details()
  }, [id])

  const handleTrailer = (video) => {
    // setTrailer(
    //   <iframe
    //     className=" p-8 w-[400px] h-[300px] rounded-md"
    //     src={`https://www.youtube.com/embed/${video.key}`}
    //   ></iframe>,
    // )
  }

  console.log(movie, 'hhgffss')
  console.log(videos, 'kkkk')

  return (
    <div>
      {loading ? (
        <div className='flex justify-center items-center font-bold text-3xl py-20'>
           <ImSpinner/>
            <h1>Loading....</h1>
        </div>
        
      ) : (
        <div className='overflow-hidden'>
          <div>
            <img
              src={`https://image.tmdb.org/t/p/original/${movie.backdrop_path}`}
              alt=""
              className="w-full h-[600px] object-fill "
            />
            <div>
              <button onClick={() => handleTrailer}>ShowTrailer</button>
            </div>
          </div>

          <div className=" bg-[#f3eded] w-full h-auto">
            <div className="flex-col flex md:flex-row items-center p-20  ">
              {/* <img src={`https://image.tmdb.org/t/p/original/${movie.logo_path}`} alt="" /> */}
              <img
                src={`https://image.tmdb.org/t/p/original/${movie.poster_path}`}
                alt=""
                className="w-[500px] h-[700px] object-cover rounded-md bg-gradient-from"
              />
              <div className="px-[5rem]">
                <h2 className="font-bold leading-8 text-4xl py-4 ">
                  {movie.title}
                </h2>
                <h2 className="w-[500px]">{movie.overview}</h2>
              </div>
            </div>
            <div className="px-20 font-bold text-3xl border-b-4 border-indigo-500 w-[3rem] ">
              Videos
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4 justify-center place-items-center ">
              {videos.map((video) => (
                <div key={video.id}>
                  <div>
                    <iframe
                      title="key"
                      className=" w-[400px] h-[300px] rounded-md py-8 px-8"
                      src={`https://www.youtube.com/embed/${video.key}`}
                    ></iframe>
                    <h2 className="px-[3rem] py-2 font-[500] hover:shadow-blue-600">
                      {video.name}
                    </h2>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default MovieDetails
